export default function (device) {
  if (
    device.device_type === "camera" ||
    device.proxy_type === "camera" ||
    device.panel_device_type === "camera_manager"||
    device.panel_device_type === "vxg" ||
    device.panel_device_type === "vms"
  ) {

    if (device.id_type === 1 || (device.device && device.device.id_type === 1)) {
      return `SBO/Camara PTZ/Camara PTZ.svg`;
    }

    return `SBO/Camara Minidomo/Camara minidomo.svg`;
  }

  if (device.camera_type === "interphone" || device.panel_device_type === "interphone") {
    return `SBO/Interfon/Interfon.svg`;
  }

  if (device.camera_type === "density_device" || device.panel_device_type === "density_device") {
    return `SBO/Generador de Neblina/Generador neblina.svg`;
  }

  if (device.camera_type === "button" || device.camera_type === "router") {
    return `SBO/Boton/Boton.svg`;
  }

  if (device.id_router) {
    device.camera_type = "router"
    return `SBO/Boton/Boton.svg`;
  }

  if (device.device_type === 'sensor') {
    switch (device.id_type_sensor) {
      case 3:
        return `SBO/Vibracion/vibracion.svg`;
      case 10:
        return `SBO/Sensor de Humedad/Sensor humedad.svg`;
      case 11:
        return `SBO/Contacto Seco/Contacto seco.svg`;
      case 13:
        return `SBO/Voltaje/voltaje.svg`;
      default:
        return `SBO/Sensor de Temperatura/Sensor Temperatura.svg`;
    }
  }

  if (device.device_type === 'doors' || device.panel_device_type === 'bosch_door' || device.device_type === 'door' || device.panel_device_type === 'door') {
    return `SBO/Alarm bridge/door.svg`;
  }

  if (device.device_type === 'area' || device.panel_device_type === 'bosch_area' || device.panel_device_type === 'dmp_area' || device.panel_device_type === 'area') {
    return `SBO/Alarm bridge/area.svg`;
  }

  if (device.device_type === 'input') {
    return `SBO/Alarm bridge/input.svg`;
  }

  if (device.device_type === 'output' || device.panel_device_type === 'bosch_output' || device.panel_device_type === 'dmp_output' || device.panel_device_type === 'output') {
    return `SBO/Alarm bridge/output.svg`;
  }

  if (device.device_type === 'zone24h' || device.panel_device_type === 'dmp_zone24h' || device.panel_device_type === 'zone24h') {
    return `SBO/Alarm bridge/zone24h.svg`;
  }

  if (
    device.device_type === 'zone' || 
    device.panel_device_type === 'bosch_zone' || 
    device.panel_device_type === 'dmp_zone' ||
    device.panel_device_type === 'zone'  
  ) {
    return `SBO/Alarm bridge/marker.svg`;
  }

  if (
    device.panel_device_type === 'bosch_panel' ||
    device.panel_device_type === 'dmp_panel' ||
    device.panel_device_type === 'intelbras_panel'
  ) {
    return `SBO/Alarm bridge/panel-de-control.png`;
  }

  if (device.panel_device_type === 'pacom_site') {
    return  `SBO/Alarm bridge/panel-de-control.png`;
  }

  if (device.panel_device_type === 'input') {
    return `SBO/Alarm bridge/input.svg`;
  }

  if (device.panel_device_type === 'output') {
    return `SBO/Alarm bridge/output.svg`;
  }

  if (device.device_type === 'alarm' || device.camera_type === 'alarm') {
    return `SBO/Salida de Alarma/Salida alarma.svg`; // fallback o null
  }

  if (device.device_type === 'alarm_bridge') {
    const { panel_device_type = null } = device;

    if (panel_device_type) {
      let isArea     = ((panel_device_type === 'bosch_area') || (panel_device_type === 'dmp_area') || (panel_device_type === 'area'));
      let isPanel    = ((panel_device_type === 'bosch_panel') || (panel_device_type === 'dmp_panel') || (panel_device_type === 'panel'));
      let isOutput   = ((panel_device_type === 'bosch_output') || (panel_device_type === 'dmp_output') || (panel_device_type === 'output'));
      let isPacomInput  = (panel_device_type === 'input');
      let isZone     = ((panel_device_type === 'bosch_zone') || (panel_device_type === 'dmp_zone') || (panel_device_type === 'zone'));
      let isDmpZone24h  = ((panel_device_type === 'dmp_zone24h') || (panel_device_type === 'zone24h'));
      let isDoor =((panel_device_type === 'bosch_door') || (panel_device_type === 'doors') || (panel_device_type === 'door'));

      if (isArea) {
        return 'SBO/Alarm bridge/area.svg';
      } else if (isPanel) {
        return 'SBO/Alarm bridge/panel-de-control.png';
      } else if (isOutput) {
        return 'SBO/Alarm bridge/output.svg';
      } else if (isZone) {
        return 'SBO/Alarm bridge/marker.svg';
      } else if (isDmpZone24h) {
        return 'SBO/Alarm bridge/zone24h.svg';
      } else if (isPacomInput) {
        return 'SBO/Alarm bridge/input.svg';
      } else if (isDoor) {
        return `SBO/Alarm bridge/door.svg`;
      }
    }

    return `SBO/Alarm bridge/panel-de-control.png`;
  }

  return `SBO/Salida de Alarma/Salida alarma.svg`;
}
